import { render } from "./CASIPentagons.vue?vue&type=template&id=e88430f2&scoped=true"
import script from "./CASIPentagons.vue?vue&type=script&lang=js"
export * from "./CASIPentagons.vue?vue&type=script&lang=js"

import "./CASIPentagons.vue?vue&type=style&index=0&id=e88430f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e88430f2"]])

export default __exports__